import * as React from "react";
const SvgFiRrFaceEyesXmarks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-eyes-xmarks_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10m6.707-13.293L17.414 10l1.293 1.293a.999.999 0 1 1-1.414 1.414L16 11.414l-1.293 1.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L14.586 10l-1.293-1.293a.999.999 0 1 1 1.414-1.414L16 8.586l1.293-1.293a.999.999 0 1 1 1.414 1.414M8 11.414l-1.293 1.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L6.586 10 5.293 8.707a.999.999 0 1 1 1.414-1.414L8 8.586l1.293-1.293a.999.999 0 1 1 1.414 1.414L9.414 10l1.293 1.293a.999.999 0 1 1-1.414 1.414zm6.964 5.81c.13.382-.173.775-.576.775H9.6c-.405 0-.707-.397-.573-.78.375-1.072 1.532-2.22 2.972-2.22s2.6 1.15 2.965 2.224z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-eyes-xmarks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceEyesXmarks;
